export const SIDEKICK_PORTAL_ID = 'sidekickPortal';
